import { FamilyProductSelector } from '@features/supplies/handlers/account-consumables/classDefinitions';

const dataDiv = document.getElementById('xrx-account-consumables-data-div');
let locale = 'en_US';
let url = 'https://www.xerox.com/assets/json/jquery.cotdata.js';
if (dataDiv && dataDiv.dataset) {
  if (dataDiv.dataset.locale) {
    locale = dataDiv.dataset.locale;
  }
  if (dataDiv.dataset.coturl) {
    url = dataDiv.dataset.coturl;
  }
}

const selector = new FamilyProductSelector(locale, url);
selector.setup();
